import http from "../helpers/httpCommon";

class UserService {
    create(data) {
        return http().post("/usersCreate", data);
    }

    read(data) {
        return http().post("/usersRead", data);
    }

    update(data) {
        return http().post(`/usersUpdate`, data);
    }

    delete(data) {
        return http().post(`/usersDelete`, data);
    }

    list(data) {
        return http().post("/usersSelectList", data)
    }
}

export default new UserService();
